export default __webpack_public_path__ + "static/media/81g.e2ba363d.svg";